@if (!loading && featureFlag) {
  <ix-application
    class="main-wrapper">
    <ix-application-header [name]="featureFlag.organizationText">
      <div
        (click)="checkMenuItems()"
        [routerLink]="'/'"
        class="placeholder-logo"
        onkeypress=""
        slot="logo">
        <img
          alt="logo-space"
          appFeatureFlagImage
          height="0"
          priority="true"
          width="0" />
      </div>
    </ix-application-header>
    <ix-menu
      #menu
      [showSettings]="false"
      [showAbout]="false"
      [enableToggleTheme]="true"
      i18nLegal="{{ 'overview.legal.label' | translate }}"
      i18nSettings="{{ 'settings.label' | translate }}"
      i18nToggleTheme="{{ 'overview.toogle_theme' | translate }}">
      <ix-menu-avatar
        (logoutClick)="onLogoutClick()"
        [bottom]="email"
        [image]="userAvatar"
        [top]="userName"
        i18nLogout="{{ 'general.logout' | translate }}"
        id="overviewMenuAvatar">
      </ix-menu-avatar>
      <ng-container *appHasFeatureFlag="'BPP'">
        <ix-menu-category
          *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER', 'DATA_PROVIDER']"
          icon="document-bulk"
          id="overviewMenuBatteryGroup"
          label="{{ 'general.home' | translate }}">
          <ix-menu-item
            (click)="setMenuItems(0)"
            *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
            [active]="menuItems[0]"
            [routerLink]="'dashboard'"
            icon="chart-curve-spline"
            id="overviewMenuPassportDashboard"
            onkeypress="">{{ 'overview.menu.passport_dashboard' | translate }}
          </ix-menu-item>
          <ix-menu-item
            (click)="setMenuItems(1)"
            *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
            [active]="menuItems[1]"
            [routerLink]="'list-passports'"
            icon="search"
            id="overviewMenuListPassports"
            onkeypress=""
          >{{ 'overview.menu.find_passports' | translate }}
          </ix-menu-item>
          <ix-menu-item
            (click)="setMenuItems(2)"
            *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
            [active]="menuItems[2]"
            [routerLink]="'list-removed-passports'"
            icon="trashcan"
            id="overviewMenuListRemovedPassports"
            onkeypress="">{{ 'overview.menu.removed_passports' | translate }}
          </ix-menu-item>
          <ix-menu-item
            (click)="setMenuItems(3)"
            *ngxPermissionsOnly="['DATA_PROVIDER']"
            [active]="menuItems[3]"
            [routerLink]="'assign-attributes'"
            icon="add-document-note"
            id="overviewMenuDataRequests"
            onkeypress="">{{ 'overview.menu.data_requests' | translate }}
          </ix-menu-item>
        </ix-menu-category>
      </ng-container>
      <ng-container *appHasFeatureFlag="'PMD'">
        <ix-menu-item
            (click)="setMenuItems(4)"
            [active]="menuItems[4]"
            [routerLink]="'dpp/list-passports'"
            icon="product"
            id="overviewMenuDpp"
            onkeypress="">
            {{ 'dpp.login.product_name' | translate }}
          </ix-menu-item>
      </ng-container>
      <ng-container *appHasFeatureFlag="'UserMgmt'">
        <ix-menu-category
          *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
          icon="user-management"
          id="overviewMenuUserManagementGroup"
          label="{{'um.menu_header' | translate}}">
          <ix-menu-item
            (click)="setMenuItems(5)"
            *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
            [active]="menuItems[5]"
            [routerLink]="'list-user'"
            icon="user-group"
            id="overviewMenuUserManagement"
            onkeypress="">
            {{ 'um.headline' | translate }}
          </ix-menu-item>
          <ix-menu-item
            (click)="setMenuItems(6)"
            *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
            [active]="menuItems[6]"
            [routerLink]="'list-access-requests'"
            icon="user-key"
            id="overviewMenuAccessRequests"
            onkeypress="">
            {{ 'um.menu_access_request' | translate }}
          </ix-menu-item>
        </ix-menu-category>
      </ng-container>
      <ix-menu-settings
        class="overflow-auto"
        label="{{ 'settings.label' | translate }}">
        <ix-menu-settings-item
          label="{{ 'settings.user_settings' | translate }}">
          <app-user-settings
            (userDataChange)="onUserDataChange()"
            [userData]="userData"
          ></app-user-settings>
        </ix-menu-settings-item>
        <ix-menu-settings-item
          *ngxPermissionsOnly="['SYS_ADMIN']"
          label="{{'organizations.settings.tab_org_settings_header' | translate}}">
          <app-organizations-settings></app-organizations-settings>
        </ix-menu-settings-item>
        <ix-menu-settings-item
          *ngxPermissionsOnly="['SYS_ADMIN']"
          label="{{'organizations.settings.tab_email_sender_settings_header' | translate}}">
          <app-email-sender-config></app-email-sender-config>
        </ix-menu-settings-item>
        <ix-menu-settings-item
          *ngxPermissionsOnly="['SYS_ADMIN']"
          label="{{'organizations.brand_domains.tab_header' | translate}}">
          <app-brand-domain-settings></app-brand-domain-settings>
        </ix-menu-settings-item>
        @if (isCatenaXEnabled) {
          <ix-menu-settings-item
            *ngxPermissionsOnly="['SYS_ADMIN']"
            label="{{'organizations.settings.tab_edc_consumer_settings_header' | translate}}">
            <app-edc-config type="consumer"></app-edc-config>
          </ix-menu-settings-item>
        }
        @if (isCatenaXEnabled) {
          <ix-menu-settings-item
            *ngxPermissionsOnly="['SYS_ADMIN']"
            label="{{'organizations.settings.tab_edc_provider_settings_header' | translate}}">
            <app-edc-config type="provider"></app-edc-config>
          </ix-menu-settings-item>
        }
      </ix-menu-settings>
      <ix-menu-about [label]="'about.headline' | translate">
        <ix-menu-about-item label="{{ 'about.general' | translate }}">
          <div class="d-flex flex-column">
            <p>
              {{ 'general.copyright' | translate: {year: getCopyRightYear()} }}
            </p>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.corporate_information_link' | translate }}">
              {{ 'overview.legal.corporate_information' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.customer_agreement_link' | translate }}">
              {{ 'overview.legal.customer_agreement' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.data_exchange_link' | translate }}">
              {{ 'overview.legal.data_exchange' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.data_privacy_link' | translate }}">
              {{ 'overview.legal.data_privacy' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.aup_link' | translate }}">
              {{ 'overview.legal.aup' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.release_notes_link' | translate }}">
              {{ 'overview.legal.release_notes' | translate }}
            </ix-link-button>
            <ix-link-button
              target="_blank"
              url="{{ 'overview.legal.oss_readme_link' | translate }}">
              {{ 'overview.legal.oss_readme' | translate }}
            </ix-link-button>
          </div>
        </ix-menu-about-item>
      </ix-menu-about>
      <ix-menu-item
        (click)="openFeedbackModal()"
        *ngxPermissionsOnly="['SYS_ADMIN', 'DATA_MANAGER']"
        id="feedback"
        onkeypress=""
        slot="bottom"
        tab-icon="notification">
        {{ 'feedback.section_headline' | translate }}
      </ix-menu-item>
    </ix-menu>
    <div class="h-100 w-100">
      <router-outlet></router-outlet>
    </div>
  </ix-application>
}

<app-global-alert></app-global-alert>

@if (loading) {
  <div
    class="d-flex justify-content-center align-items-center main-wrapper">
    <ix-spinner size="large"></ix-spinner>
  </div>
}

<ng-template #feedbackModal let-modal>
  <div>
    <ix-modal-header>
      {{ 'feedback.section_headline' | translate }}
    </ix-modal-header>
    <app-feedback-form (submitted)="modal.close(true)"></app-feedback-form>
  </div>
</ng-template>
